import { useMemo } from 'react';
import { useGetPortalNavigationQuery } from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/NavigationRpc.hooks';
import {
  buildPortalNavigation,
  type PortalNavigationData,
  type SideNavItemData,
} from '../utils/portalNavigation';
import {
  getPortalAccountId,
  getPortalInstanceId,
  getIsPortalDeployed,
} from '../utils/metadata';

export type { SideNavItemData, PortalNavigationData };

// currentPathname should be passed by consumers using a router (e.g. from
// react-router's useLocation) so the active item updates on client-side
// navigation. Falls back to window.location.pathname if not supplied — this
// only stays fresh across full page loads.
export function usePortalNavigation(
  currentPathname?: string
): PortalNavigationData {
  const { data, loading } = useGetPortalNavigationQuery({
    variables: {
      accountId: getPortalAccountId(),
      portalInstanceId: getPortalInstanceId(),
    },
  });
  const isLocal = !getIsPortalDeployed();
  const pathname = currentPathname ?? window.location.pathname;
  return useMemo(
    () =>
      buildPortalNavigation({
        data,
        loading,
        isLocal,
        currentPathname: pathname,
      }),
    [data, loading, isLocal, pathname]
  );
}
